export class Factura{
    public nombre: string = '';
    public paterno: string = '';
    public materno: string = '';
    public telefono: string = '';
    public correo: string = '';
    public rfc: string = '';
    public clave: string = '';
    public nacimiento: string = '';
    public cp: string = '';
    public estado: string = '';
    public ciudad: string = '';
    public municipio: string = '';
    public colonia: string = '';
    public calle: string = '';
    public exterior: number;
    public indicaciones: string = '';
    public regimenFiscal: string = '';
    public usoCfdi: string = '';
    constructor(){}
  }